<template>
  <div class="view view-single-winner" id="spot">
    <div class="content" id="browse">
      <div class='inside-closer' v-on:click="close">✖</div>
      <div class='sub-heading padding-20'>Uställare 2017</div>
      <div class='heading'>Exhibition Stockholm</div>
      <div class='sub-heading padding-40 pad-sides'>
        {{photographer}}
      </div>
      <div v-if="photosLoaded === true" style='padding: 15px 0px;'>
        <photoFeed v-bind:photos="winnerPhotos" show-user="true">
          <div slot="empty">Något gick fel, prova ladda om sidan!</div>
        </photoFeed>
      </div>
      <div v-else><loader colorClass='black'></loader></div>
      <div class='padding-80'></div>
      <div class='padding-80'></div>
    </div>
  </div>
</template>

<script>
import loader from '@/components/Loader'
import photoFeed from '@/components/photoFeed'
import db from '@/classes/Db'
export default {
  name: 'singleFeed',
  data () {
    return {
      browsing: true,
      photosLoaded: false,
      winnerPhotos: [],
      photographer: 'Hämtar...'
    }
  },
  props: ['photoid'],
  methods: {
    close () {
      this.$emit('close')
    },
    browsePhotos () {
      this.browsing = true
    },
    getWinner () {
      db.database().ref('finalwinners/' + this.photoid).once('value', (snapshot) => {
        let valn = snapshot.val()
        this.winnerPhotos.push(valn)
        this.photographer = valn.username
        this.photosLoaded = true
      })
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.getWinner()
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Single Winner Feed')
    }
  },
  beforeDestroy () {
  },
  components: { loader, photoFeed }
}
</script>

<style scoped>
  .view-single-winner {
    position: absolute;
    top: 0px;
    min-height: 100vh;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// singleFeed.vue?46e039f5